import React, { createContext, useContext, useMemo } from 'react';
import { isFeatureOn } from './utils';

interface FeatureFlagsProviderProps {
  children: React.ReactNode;
}

const FeatureFlagsContext = createContext({
  isDBOEnabled: false,
  isGuaranteesEnabled: false,
  isTasksEnabled: false,
  isUpdatingDataFopEnabled: false,
  isUpdatingDataLegalResidentEnabled: false,
  isCRSIFopEnabled: false,
  isOwnershipStructureTreeEnabled: false,
  isOwnershipStructureTreeReIdentificationEnabled: false,
  isTestEnvironmentEnabled: false,
  isAdditionalInformationAboutTaxResidencyEnabled: false,
  isFATCALegalResidentEnabled: false,
  isFATCAFopEnabled: false,
  isOpeningGrantAccountingAccount2603Enabled: false,
});

export const FeatureFlagsProvider = ({ children }: FeatureFlagsProviderProps) => {
  const isDBOEnabled = isFeatureOn('VITE_DBO');
  const isGuaranteesEnabled = isFeatureOn('VITE_GUARANTEES');
  const isTasksEnabled = isFeatureOn('VITE_TASKS');
  const isUpdatingDataFopEnabled = isFeatureOn('VITE_UPDATING_DATA_FOP_ENABLED');
  const isUpdatingDataLegalResidentEnabled = isFeatureOn(
    'VITE_UPDATING_DATA_LEGAL_RESIDENT_ENABLED'
  );
  const isCRSIFopEnabled = isFeatureOn('VITE_CRSI_FOP_ENABLED');
  const isOwnershipStructureTreeEnabled = isFeatureOn('VITE_OWNERSHIP_STRUCTURE_TREE_ENABLED');
  const isOwnershipStructureTreeReIdentificationEnabled = isFeatureOn(
    'VITE_OWNERSHIP_STRUCTURE_TREE_RE_IDENTIFICATION_ENABLED'
  );
  const isTestEnvironmentEnabled = isFeatureOn('VITE_TEST_ENVIRONMENT_ENABLED');
  const isAdditionalInformationAboutTaxResidencyEnabled = isFeatureOn(
    'VITE_ADDITIONAL_INFORMATION_ON_TAX_RESIDENCE_ENABLED'
  );
  const isFATCALegalResidentEnabled = isFeatureOn('VITE_FATCA_LEGAL_RESIDENT_ENABLED');
  const isFATCAFopEnabled = isFeatureOn('VITE_FATCA_FOP_ENABLED');
  const isOpeningGrantAccountingAccount2603Enabled = isFeatureOn(
    'VITE_OPENING_GRANT_ACCOUNTING_ACCOUNT_2603'
  );

  const value = useMemo(
    () => ({
      isDBOEnabled: isDBOEnabled,
      isGuaranteesEnabled: isGuaranteesEnabled,
      isTasksEnabled: isTasksEnabled,
      isUpdatingDataFopEnabled: isUpdatingDataFopEnabled,
      isUpdatingDataLegalResidentEnabled: isUpdatingDataLegalResidentEnabled,
      isCRSIFopEnabled: isCRSIFopEnabled,
      isOwnershipStructureTreeEnabled: isOwnershipStructureTreeEnabled,
      isOwnershipStructureTreeReIdentificationEnabled:
        isOwnershipStructureTreeReIdentificationEnabled,
      isTestEnvironmentEnabled: isTestEnvironmentEnabled,
      isAdditionalInformationAboutTaxResidencyEnabled:
        isAdditionalInformationAboutTaxResidencyEnabled,
      isFATCALegalResidentEnabled: isFATCALegalResidentEnabled,
      isFATCAFopEnabled: isFATCAFopEnabled,
      isOpeningGrantAccountingAccount2603Enabled: isOpeningGrantAccountingAccount2603Enabled,
    }),
    []
  );

  return <FeatureFlagsContext.Provider value={value}>{children}</FeatureFlagsContext.Provider>;
};

export const useFeatureFlags = () => useContext(FeatureFlagsContext);
